import React from "react";
import PropTypes from "prop-types";
import {AIcon} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import css from "./ImportantEventIcon.module.scss";

const ImportantEventIcon = ({className}) => (
  <AIcon
    size={8}
    className={classNames(css.notableIcon, className)}
    data-testid={"ImportantEventIcon"}>
    circle
  </AIcon>
);

ImportantEventIcon.propTypes = {
  classNames: PropTypes.string
};

export default ImportantEventIcon;
